import React, { useState, useEffect, useRef, useCallback } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { PageCurso } from "./horarioCurso/PageCurso";
import { PageAsignatura } from "./horarioCurso/PageAsignatura";
import { PageElectivo } from "./horarioCurso/PageElectivo";
import { PageBloque } from "./horarioCurso/PageBloque";
import { PageHorario } from "./horarioCurso/PageHorario";
import { accionPermiso } from "../../utilities/Seguridad";
import { useDispatch, useSelector } from "react-redux";
import "./TabViewDemo.css";

export const PageHorarioCurso = () => {
    // Permisos
    const permisos = useRef({ superusuario: false, acciones: [] });
    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    const getViewTab = (name) => {
        try {
            permisos.current.superusuario = usuario.superusuario;
            permisos.current.acciones = usuario.permisos.mantenedor[name].acciones;
        } catch (error) {
            permisos.current.acciones = [];
        }
        return !accionPermiso(permisos, "ver");
    }

    return (
        <div className="card p-m-0 p-p-0" style={{ height: "calc(100vh - 120px)" }}>
        <TabView>
            <TabPanel header="1. CURSOS" disabled={getViewTab("curso")}>
                {getViewTab("curso") ? "" : <PageCurso />};
            </TabPanel>
            <TabPanel header="2-1 ASIGNATURAS" disabled={getViewTab("asignaturas")}>
                {getViewTab("asignaturas") ? "" : <PageAsignatura />};
            </TabPanel>
            <TabPanel header="2-2 TALLERES" disabled={getViewTab("taller")}>
                {getViewTab("taller") ? "" : <PageElectivo />};
            </TabPanel>
            <TabPanel header="3. BLOQUES" disabled={getViewTab("bloque")}>
                {getViewTab("bloque") ? "" : <PageBloque />};
            </TabPanel>
            <TabPanel header="4. HORARIOS" disabled={getViewTab("horario")}>
                {getViewTab("horario") ? "" : <PageHorario />}
            </TabPanel>
        </TabView>
        </div>
    );
};
